

import React from 'react';
import MaskedInput from 'react-text-mask';

interface Props {
  inputRef: (ref: HTMLInputElement | null) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TextMaskCustom = React.forwardRef<HTMLInputElement, Props>(function TextMaskCustom(
  props,
  ref
) {
  const { inputRef, onChange, ...other } = props;

  return (
    <MaskedInput
      {...other}
      mask={[
        /[1-9]/, /\d/, /\d/, // first 3 digits
        '-',                 // dash
        /\d/, /\d/, /\d/,    // next 3 digits
        '-',                 // dash
        /\d/, /\d/, /\d/, /\d/ // last 4 digits
      ]}
      placeholderChar={'\u2000'}
      showMask
      onChange={onChange}
    />
  );
});

export default TextMaskCustom;
